import * as actionTypes from "Consts/actionsTypes";
import { languageFieldActions } from "../actions";

const defaultState = {
	show: false,
	url: "",
	name: "",
};

export const languageField = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.LANGUAGE_FIELD__TOGGLE:
			state = {
				...state,
				show: action.payload.show,
			};
			break;
	}
	return state;
};
